import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { useDispatch, useSelector } from "react-redux";
import TableDataComponent from "../../components/parking-excel/TableDataComponent";
import TotalLineComponent from "../../components/parking-excel/TotalLineComponent";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { useNavigate } from "react-router-dom";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";
import { format } from "date-fns";
import { Dropdown } from "primereact/dropdown";
import copyToClipboard from "../../utils/parkir-import-excel/CopyToClipboard";
import onSuccessToast from "../../utils/OnSuccessToast";

const title = "Laporan Parkiran";

const filterOptions = [
  { name: "Semua", value: "semua" },
  { name: "Mobil", value: "mobil" },
  { name: "Sepeda", value: "sepeda" },
];

const LaporanParkiranPage = (props) => {
  const navigate = useNavigate();
  const permissions = useSelector((state) => state.auth.permissions);

  const toastRef = useRef(null);
  const dispatch = useDispatch();
  const [tax, setTax] = useState(0);
  const [date, setDate] = useState([new Date(), new Date()]);
  const [data, setData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0].value);
  const { requestGet, loading } = useAPIRequest();

  useEffect(() => {
    if (!permissions.includes("view laporanparkiran")) {
      navigate("/");
    }
    dispatch(setLayoutDashboardTitle({ title }));

    loadSetting();
    // reloadData();
  }, []);

  const handleCopyData = () => {
    copyToClipboard({
      fields: [
        "no",
        "jenis",
        "masuk_tanggal",
        "masuk_op",
        "keluar_tanggal",
        "keluar_kasir",
        "nomor_plat",
        "lama",
        "jumlah",
      ],
      data,
    });
    onSuccessToast({
      toast: toastRef,
      message: "Data berhasil di-copy",
      data: {},
    });
  };

  const generateFilter = () => {
    let filter = "";
    let firstDate, secondDate;
    if (date.length > 0) {
      firstDate = date[0];
    }
    if (date.length > 1) {
      secondDate = date[1];
    }

    if (firstDate && secondDate) {
      const nextDate = new Date(secondDate);
      nextDate.setDate(nextDate.getDate() + 1);
      filter += `keluar_tanggal:>=:${format(
        firstDate,
        "yyyy-MM-dd"
      )} 00:00:00;keluar_tanggal:<:${format(nextDate, "yyyy-MM-dd")} 00:00:00;`;
    } else if (firstDate) {
      const nextDate = new Date(firstDate);
      nextDate.setDate(nextDate.getDate() + 1);
      filter += `keluar_tanggal:>=:${format(
        firstDate,
        "yyyy-MM-dd"
      )} 00:00:00;keluar_tanggal:<:${format(nextDate, "yyyy-MM-dd")} 00:00:00;`;
    }

    filter += ";jumlah_edited:>:0";

    if (selectedFilter && selectedFilter !== "semua") {
      filter += `;jenis:contains:%${selectedFilter}%`;
    }

    return filter;
  };

  const loadSetting = () => {
    const filter = `label:=:tax`;

    requestGet({
      fullUrl: "api/setting/data",
      params: {
        filter,
        page: 1,
        take: 1000000,
        order: "id",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        let _tax = 0;
        if (data && data.length > 0) {
          _tax = data[0].value_number;
          setTax(_tax);
        }
        reloadData(_tax);
      },
      onError: ({ message, data }) => {},
    });
  };

  const reloadData = (_tax) => {
    setData([]);
    const newTax = _tax ? _tax : tax;

    const filter = generateFilter();
    if (!filter) {
      return;
    }

    requestGet({
      fullUrl: "api/transaksi/dataparkir/data",
      params: {
        filter,
        page: 1,
        take: 1000000,
        order: "id",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        if (data) {
          for (let i = 0; i < data.length; i++) {
            data[i].no = i + 1;
            if (newTax && newTax > 0) {
              data[i].jumlah = data[i].jumlah - (data[i].jumlah * newTax) / 100;
            }
          }
          setData(data);
        }
      },
      onError: ({ message, data }) => {},
    });
  };

  const reloadHandler = (event) => {
    reloadData();
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <Toast ref={toastRef} />
      <ConfirmDialog />
      <div className="elevated-card col-start-start w-full gap-4">
        {/* header - tanggal & upload */}
        <div className="row-between-center gap-3 w-full">
          <div className="row-start-center gap-2">
            <span>Tanggal</span>
            <Calendar
              className="max-w-[20rem]"
              selectionMode="range"
              value={date}
              onChange={(e) => setDate(e.value)}
              showIcon
            />
            <Dropdown
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.value)}
              options={filterOptions}
              optionLabel="name"
              className="w-[10rem]"
            />
            <Button
              label="Load Data"
              icon="pi pi-refresh"
              loading={loading}
              onClick={reloadHandler}
            />
          </div>
          <Button label="Copy" icon="pi pi-copy" onClick={handleCopyData} />
        </div>

        {/* total */}
        <TotalLineComponent
          listData={data}
          labelField={"jenis"}
          totalField={"jumlah"}
        />

        {/* tabel */}
        <TableDataComponent data={data} />
      </div>
    </div>
  );
};

export default LaporanParkiranPage;
